import OapSkindrAppWrapper from './code/Scripts/components/OapSkindrAppWrapper/OapSkindrAppWrapper.vue';

export default {
  components: {
    OapSkindrAppWrapper,
  },
};
